import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { ZoneService } from 'src/app/services/zone.service';
import { Title } from '@angular/platform-browser';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AddZoneComponent } from '../add/add.component';
import { AWBDeleteActionsRenderer } from '../../../shared/ag-grid/cell-renderers/awb-delete.component';


@Component({
  selector: 'app-listzones',
  templateUrl: './listzones.component.html',
  styleUrls: ['./listzones.component.scss']
})
export class ListZonesComponent implements OnInit, OnDestroy {
  zonesList = [];
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isViewAllowed = false;

  public isCollapsed = true;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    resizable: false,
  };
  gridOptions: GridOptions = {
    pagination: true,
    // domLayout: 'autoHeight',
    paginationPageSize: 20
  }
  columnDefs = [
    { headerName: 'Zone Code', field: 'zonecode' },
    { headerName: 'Title', field: 'zonetitle'},
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: AWBDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      sortable: false,
      maxWidth: 140,
    },
  ];
  rowData = [];

  constructor(
    public router: Router,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private zoneService: ZoneService,
    private titleService: Title,
    private modalService: NgbModal,

  ) {
    titleService.setTitle('Zones');
    this.context = { componentParent: this , componentName: 'ListZonesComponent', deleteAction: true};
  }

  ngOnInit() {
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.bindZoneList();
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Zones');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindZoneList(refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.zoneService.GetAllList({ refresh: refresh }).subscribe((res: any) => {
        if (res && res.success) {
          // console.log(res);
          this.ngxLoaderService.stop();
          this.rowData = res.data;
        } else {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  ngOnDestroy(): void {
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
    params.api.sizeColumnsToFit();
  }

  editAction(cell: any) {
    // console.log(cell);
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        // this.router.navigate(['/setup/products/edit', cell.id]);
      }

    } catch (e) {
      console.error(e);
    }

  }

  deleteAction(cell: any) {
    // console.log(cell);
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialog('No access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
    }

  }

  deleteRecord(id) {
    try {
      if (id) {
        this.zoneService.Delete(id).subscribe((res) => {
          if (res && res.success) {
            this.appCoreService.showMessage('Record deleted successfuly','Success','success');
            this.bindZoneList(true);
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      // call delete api
      this.deleteRecord(id);

    }

  }

  warningDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  openAddLinkModal() {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    const modalRef = this.modalService.open(AddZoneComponent, ngbModalOptions);
    // modalRef.componentInstance.cellData = cell;
    modalRef.result.then(
      (reason) => {
        if (reason === 'Save Click') {
          this.bindZoneList();
        }
      },
      (reason) => {
        //on close awb POD Dialog do nothing
      }
    );
  }

}
